<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc2"><a href="#/chapter01">H<span class="small">IGHLANDS</span></a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Kalalanta: The Sea Captain Likes the View</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Gray Cottage: Little “Old-Fashioned” Boy</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Ed “Bennie” Rogers and Early Highlands Law Enforcement: Larger Than Life</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">4½ Street Inn: Scent of Lilac Wafting in the Air</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Werder Home: Oscar Likes Things Neat and Tidy</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">The Log Cabin Restaurant: Dark Shadow Figure</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Satulah Mountain: The Legend of a Magical Mountain Volcano</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Highlands Inn: The Lady in Room 34</span></p>
<p class="toc2"><span href="#/chapter10" title="Link target outside of Sample">C<span class="small">ASHIERS</span></span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Cash’s Valley: The Legend of How Cashiers Got its Name</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">The Eternal Bloody Rock: Massacre at Cold Springs</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">High Hampton Inn: The Ghost of the White Owl</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Whiteside Mountain: The Legend of Spearfinger</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Snakes Den: Jealousy for Bessie Laura</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Cedar Creek Racquet Club: Pretty Little Brenda Sue</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">Cashiers General Store: An Escalation of Ghostly Activity</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f4a23d46